import React, { Component } from "react";































































































































































































































































































































































































































































































































import {































































































































































































































































































































































































































































































































  Button,































































































































































































































































































































































































































































































































  Container,































































































































































































































































































































































































































































































































  Row, Form,































































































































































































































































































































































































































































































































  Col,































































































































































































































































































































































































































































































































  Offcanvas,































































































































































































































































































































































































































































































































} from "react-bootstrap";































































































































































































































































































































































































































































































































import { toast } from "react-toastify";































































































































































































































































































































































































































































































































import DataTable from "react-data-table-component";































































































































































































































































































































































































































































































































import configData from '../config.json';































































































































































































































































































































































































































































































































import { ValidationUtils } from '../Sidebar/Common';































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import LoadingOverlay from "./LoadingOverlay";
export default class Table_metadata extends Component {































































































































































































































































































































































































































































































































  constructor(props) {































































































































































































































































































































































































































































































































    super(props);































































































































































































































































































































































































































































































































    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",































































































































































































































































































































































































































































































































      show: false,































































































































































































































































































































































































































































































































      data: [],































































































































































































































































































































































































































































































































      sId: sessionStorage.getItem("sessionId"),































































































































































































































































































































































































































































































































      uId: sessionStorage.getItem("uId"),































































































































































































































































































































































































































































































































      errors: {},































































































































































































































































































































































































































































































































      touched: {}, // Track which fields have been touched































































































































































































































































































































































































































































































































      filteredData: null,































































































































































































































































































































































































































































































































      tableClms: [































































































































































































































































































































































































































































































































        {































































































































































































































































































































































































































































































































          name: "S.NO",































































































































































































































































































































































































































































































































          selector: (row, i) => row.table_metadata_Id,































































































































































































































































































































































































































































































































          sortable: true,































































































































































































































































































































































































































































































































          cell: (row) => <span>{row.table_metadata_Id}</span>,































































































































































































































































































































































































































































































































        },































































































































































































































































































































































































































































































































        { name: "Table Name", selector: (row, i) => row.table_name, sortable: true, cell: (row) => <span>{row.table_name}</span>, }, { name: "Display Name", selector: (row, i) => row.display_name, sortable: true, cell: (row) => <span>{row.display_name}</span>, }, { name: "Has Rule Triggers", selector: (row, i) => row.has_rule_triggers, sortable: true, cell: (row) => <span>{row.has_rule_triggers}</span>, }, { name: "Auto Generate Rules", selector: (row, i) => row.auto_generate_rules, sortable: true, cell: (row) => <span>{row.auto_generate_rules}</span>, }, { name: "Table Config", selector: (row, i) => row.table_config, sortable: true, cell: (row) => <span>{row.table_config}</span>, },































































































































































































































































































































































































































































































































        { name: "Column Name", selector: (row, i) => row.column_name, sortable: true, cell: (row) => <span>{row.column_name}</span>, }, { name: "Data Type", selector: (row, i) => row.data_type, sortable: true, cell: (row) => <span>{row.data_type}</span>, }, { name: "Length", selector: (row, i) => row.length, sortable: true, cell: (row) => <span>{row.length}</span>, }, { name: "Is Nullable", selector: (row, i) => row.is_nullable, sortable: true, cell: (row) => <span>{row.is_nullable}</span>, }, { name: "Default Value", selector: (row, i) => row.default_value, sortable: true, cell: (row) => <span>{row.default_value}</span>, }, { name: "Is Primary Key", selector: (row, i) => row.is_primary_key, sortable: true, cell: (row) => <span>{row.is_primary_key}</span>, }, { name: "Is Auto Increment", selector: (row, i) => row.is_auto_increment, sortable: true, cell: (row) => <span>{row.is_auto_increment}</span>, }, { name: "Column Comment", selector: (row, i) => row.column_comment, sortable: true, cell: (row) => <span>{row.column_comment}</span>, }, { name: "Column Order", selector: (row, i) => row.column_order, sortable: true, cell: (row) => <span>{row.column_order}</span>, },//***tableClms































































































































































































































































































































































































































































































































        {































































































































































































































































































































































































































































































































          name: "Actions",































































































































































































































































































































































































































































































































          sortable: false,































































































































































































































































































































































































































































































































          cell: (row) => (































































































































































































































































































































































































































































































































            <div>































































































































































































































































































































































































































































































































              {/* edit button and delete button */}































































































































































































































































































































































































































































































































              <Button































































































































































































































































































































































































































































































































                style={{ marginRight: "10px" }}































































































































































































































































































































































































































































































































                variant="primary"































































































































































































































































































































































































































































































































                onClick={() => this.Table_metadataeditHandler(row)}































































































































































































































































































































































































































































































































                className="bi bi-pen"































































































































































































































































































































































































































































































































              >































































































































































































































































































































































































































































































































              </Button>































































































































































































































































































































































































































































































































              <Button































































































































































































































































































































































































































































































































                variant="danger"































































































































































































































































































































































































































































































































                onClick={() => this.handleDelete(row)}































































































































































































































































































































































































































































































































                className="bi bi-trash danger"































































































































































































































































































































































































































































































































              >































































































































































































































































































































































































































































































































              </Button>































































































































































































































































































































































































































































































































            </div>































































































































































































































































































































































































































































































































          ),































































































































































































































































































































































































































































































































        },































































































































































































































































































































































































































































































































      ],































































































































































































































































































































































































































































































































      currentPage: 1,































































































































































































































































































































































































































































































































      itemsPerPage: 10,































































































































































































































































































































































































































































































































      isEditing: false,































































































































































































































































































































































































































































































































      table_metadata_Id: "",































































































































































































































































































































































































































































































































      table_name: '', display_name: '', yes_no: [], has_rule_triggers: '', yes_no: [], auto_generate_rules: '', table_config: '',































































































































































































































































































































































































































































































































      column_name: '', data_type: '', length: '', yes_no: [], is_nullable: '', default_value: '', yes_no: [], is_primary_key: '', yes_no: [], is_auto_increment: '', column_comment: '', column_order: '',//***state































































































































































































































































































































































































































































































































    };































































































































































































































































































































































































































































































































  }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  // Enhanced validation method using Common.js with auto-generated logic































































































































































































































































































































































































































































































































  validateField = (fieldName, value, fieldConfig) => {































































































































































































































































































































































































































































































































    const { inputType, validationOptions } = fieldConfig;































































































































































































































































































































































































































































































































    const fieldDisplayName = fieldConfig.displayName || fieldName;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    let validationResult = { isValid: true, message: "" };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    // Auto-generated validation based on inputType and validationOptions































































































































































































































































































































































































































































































































    switch (inputType.toLowerCase()) {































































































































































































































































































































































































































































































































      case 'text':































































































































































































































































































































































































































































































































        if (validationOptions?.isName) {































































































































































































































































































































































































































































































































          validationResult = ValidationUtils.validateName(value);































































































































































































































































































































































































































































































































        } else if (validationOptions?.isAddress) {































































































































































































































































































































































































































































































































          validationResult = ValidationUtils.validateAddress(value);































































































































































































































































































































































































































































































































        } else if (validationOptions?.maxLength) {































































































































































































































































































































































































































































































































          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);































































































































































































































































































































































































































































































































        } else {































































































































































































































































































































































































































































































































          validationResult = { isValid: true, message: "" };































































































































































































































































































































































































































































































































        }































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'mail':































































































































































































































































































































































































































































































































      case 'email':































































































































































































































































































































































































































































































































        validationResult = ValidationUtils.validateEmail(value);































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'telephone':































































































































































































































































































































































































































































































































      case 'phone':































































































































































































































































































































































































































































































































        validationResult = ValidationUtils.validatePhone(value);































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'number':































































































































































































































































































































































































































































































































        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'dob_child':































































































































































































































































































































































































































































































































        validationResult = ValidationUtils.validateDOBMinAge(value);































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'dob_adult':































































































































































































































































































































































































































































































































        validationResult = ValidationUtils.validateDOBAdult(value);































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'pan':































































































































































































































































































































































































































































































































        validationResult = ValidationUtils.validatePAN(value);































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'aadhaar':































































































































































































































































































































































































































































































































        validationResult = ValidationUtils.validateAadhaar(value);































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'password':































































































































































































































































































































































































































































































































        if (value.length < 6) {































































































































































































































































































































































































































































































































          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };































































































































































































































































































































































































































































































































        }































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      default:































































































































































































































































































































































































































































































































        validationResult = { isValid: true, message: "" };































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    // Check required field validation































































































































































































































































































































































































































































































































    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {































































































































































































































































































































































































































































































































      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    const errors = { ...this.state.errors };































































































































































































































































































































































































































































































































    if (!validationResult.isValid) {































































































































































































































































































































































































































































































































      errors[fieldName] = validationResult.message;































































































































































































































































































































































































































































































































    } else {































































































































































































































































































































































































































































































































      delete errors[fieldName];































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    this.setState({ errors });































































































































































































































































































































































































































































































































    return validationResult.isValid;































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  // Enhanced field change handler with auto-validation































































































































































































































































































































































































































































































































  handleFieldChange = (fieldName, value, fieldConfig) => {































































































































































































































































































































































































































































































































    this.setState({































































































































































































































































































































































































































































































































      [fieldName]: value,































































































































































































































































































































































































































































































































      touched: { ...this.state.touched, [fieldName]: true }































































































































































































































































































































































































































































































































    });































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    // Only validate if field has been touched































































































































































































































































































































































































































































































































    if (this.state.touched[fieldName] || value !== "") {































































































































































































































































































































































































































































































































      this.validateField(fieldName, value, fieldConfig);































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  // Enhanced field blur handler for validation































































































































































































































































































































































































































































































































  handleFieldBlur = (fieldName, value, fieldConfig) => {































































































































































































































































































































































































































































































































    this.setState({































































































































































































































































































































































































































































































































      touched: { ...this.state.touched, [fieldName]: true }































































































































































































































































































































































































































































































































    });































































































































































































































































































































































































































































































































    this.validateField(fieldName, value, fieldConfig);































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  // Check if form is valid - auto-generated based on required fields































































































































































































































































































































































































































































































































  isFormValid = () => {































































































































































































































































































































































































































































































































    const { errors } = this.state;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    // Auto-generated required field validation































































































































































































































































































































































































































































































































    // Auto-generated required field validation































































































































































































































































































































































































































































































































    const requiredFields = ['table_name'];































































































































































































































































































































































































































































































































    for (const field of requiredFields) {































































































































































































































































































































































































































































































































      if (!this.state[field] || this.state[field].toString().trim() === '') {































































































































































































































































































































































































































































































































        return false;































































































































































































































































































































































































































































































































      }































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    return Object.keys(errors).length === 0;































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  // Auto-generated validation for all fields before submission































































































































































































































































































































































































































































































































  validateAllFields = () => {































































































































































































































































































































































































































































































































    const fieldConfigs = [































































































































































































































































































































































































































































































































      { fieldName: 'table_name', inputType: 'Text', displayName: 'Table Name', validationOptions: { isRequired: true, maxLength: 100 } },































































































































































































































































































































































































































































































































      { fieldName: 'display_name', inputType: 'Text', displayName: 'Display Name', validationOptions: { isRequired: false } },































































































































































































































































































































































































































































































































      { fieldName: 'has_rule_triggers', inputType: 'Select', displayName: 'Has Rule Triggers', validationOptions: { isRequired: false } },































































































































































































































































































































































































































































































































      { fieldName: 'auto_generate_rules', inputType: 'Select', displayName: 'Auto Generate Rules', validationOptions: { isRequired: false } },































































































































































































































































































































































































































































































































      { fieldName: 'table_config', inputType: 'Text', displayName: 'Table Config', validationOptions: { isRequired: false } }































































































































































































































































































































































































































































































































    ];































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    fieldConfigs.forEach(config => {































































































































































































































































































































































































































































































































      const value = this.state[config.fieldName];































































































































































































































































































































































































































































































































      this.validateField(config.fieldName, value, config);































































































































































































































































































































































































































































































































    });































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    const touched = {};































































































































































































































































































































































































































































































































    fieldConfigs.forEach(config => {































































































































































































































































































































































































































































































































      touched[config.fieldName] = true;































































































































































































































































































































































































































































































































    });































































































































































































































































































































































































































































































































    this.setState({ touched });































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  // offcanvas Open































































































































































































































































































































































































































































































































  handleOffcanvasShow = () => {































































































































































































































































































































































































































































































































    this.setState({































































































































































































































































































































































































































































































































      show: true,































































































































































































































































































































































































































































































































      errors: {},































































































































































































































































































































































































































































































































      touched: {},































































































































































































































































































































































































































































































































      table_name: '', display_name: '', yes_no: [], has_rule_triggers: '', yes_no: [], auto_generate_rules: '', table_config: '',































































































































































































































































































































































































































































































































    });































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  // Offcanvas close button































































































































































































































































































































































































































































































































  handleOffcanvasClose = () => {































































































































































































































































































































































































































































































































    this.setState({































































































































































































































































































































































































































































































































      show: false,































































































































































































































































































































































































































































































































      isEditing: false,































































































































































































































































































































































































































































































































      errors: {},































































































































































































































































































































































































































































































































      touched: {},































































































































































































































































































































































































































































































































      table_name: '', display_name: '', yes_no: [], has_rule_triggers: '', yes_no: [], auto_generate_rules: '', table_config: '',































































































































































































































































































































































































































































































































    });































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  // Enhanced toast notifications































































































































































































































































































































































































































































































































  showToast = (msg, type) => {































































































































































































































































































































































































































































































































    switch (type) {































































































































































































































































































































































































































































































































      case "success":































































































































































































































































































































































































































































































































        toast.success(msg);































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































      case "error":































































































































































































































































































































































































































































































































        toast.error(msg);































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































      case "warning":































































































































































































































































































































































































































































































































        toast.warn(msg);































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































      default:































































































































































































































































































































































































































































































































        toast.info(msg);































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  Table_metadataeditHandler = (row) => {































































































































































































































































































































































































































































































































    this.setState({































































































































































































































































































































































































































































































































      isEditing: true,































































































































































































































































































































































































































































































































      show: true,































































































































































































































































































































































































































































































































      table_metadata_Id: row.table_metadata_Id,































































































































































































































































































































































































































































































































      table_name: row.table_name, display_name: row.display_name, yes_no: [], has_rule_triggers: row.has_rule_triggers, yes_no: [], auto_generate_rules: row.auto_generate_rules, table_config: row.table_config,































































































































































































































































































































































































































































































































      column_name: row.column_name, data_type: row.data_type, length: row.length, yes_no: [], is_nullable: row.is_nullable, default_value: row.default_value, yes_no: [], is_primary_key: row.is_primary_key, yes_no: [], is_auto_increment: row.is_auto_increment, column_comment: row.column_comment, column_order: row.column_order,//***editstate































































































































































































































































































































































































































































































































      errors: {},































































































































































































































































































































































































































































































































      touched: {}































































































































































































































































































































































































































































































































    });































































































































































































































































































































































































































































































































  }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  Table_metadatafetchHandler = () => {































































































































































































































































































































































































































































































































    var formData = new FormData();































































































































































































































































































































































































































































































































    formData.append("sId", this.state.sId);































































































































































































































































































































































































































































































































    formData.append("uId", this.state.uId);































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    fetch(configData.api_url + 'C_Table_metadata/list', {































































































































































































































































































































































































































































































































      method: 'POST',































































































































































































































































































































































































































































































































      mode: 'cors',































































































































































































































































































































































































































































































































      body: formData































































































































































































































































































































































































































































































































    })































































































































































































































































































































































































































































































































      .then(response => response.json())































































































































































































































































































































































































































































































































      .then((data) => {































































































































































































































































































































































































































































































































        if (data.status === "success") {































































































































































































































































































































































































































































































































          this.setState({ data: data.list });































































































































































































































































































































































































































































































































        }































































































































































































































































































































































































































































































































      })































































































































































































































































































































































































































































































































      .catch((error) => {































































































































































































































































































































































































































































































































        console.error("Fetch error:", error);































































































































































































































































































































































































































































































































        this.showToast("Failed to load data", "error");































































































































































































































































































































































































































































































































      });































































































































































































































































































































































































































































































































  }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  Table_metadatasubmitHandler = (e) => {































































































































































































































































































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    // Validate all fields before submission































































































































































































































































































































































































































































































































    this.validateAllFields();































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    if (!this.isFormValid()) {































































































































































































































































































































































































































































































































      this.showToast("Please fix all errors before submitting", "error");































































































































































































































































































































































































































































































































      return;































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    var formData = new FormData();































































































































































































































































































































































































































































































































    formData.append("sId", this.state.sId);































































































































































































































































































































































































































































































































    formData.append("uId", this.state.uId);































































































































































































































































































































































































































































































































    formData.append('table_name', this.state.table_name);































































































































































































































































































































































































































































































































    formData.append('display_name', this.state.display_name);































































































































































































































































































































































































































































































































    formData.append('has_rule_triggers', this.state.has_rule_triggers);































































































































































































































































































































































































































































































































    formData.append('auto_generate_rules', this.state.auto_generate_rules);































































































































































































































































































































































































































































































































    formData.append('table_config', this.state.table_config);































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    formData.append('column_name', this.state.column_name);































































































































































































































































    formData.append('data_type', this.state.data_type);































































































































    formData.append('length', this.state.length);































































    formData.append('is_nullable', this.state.is_nullable);































    formData.append('default_value', this.state.default_value);















    formData.append('is_primary_key', this.state.is_primary_key);







    formData.append('is_auto_increment', this.state.is_auto_increment);



    formData.append('column_comment', this.state.column_comment);

    formData.append('column_order', this.state.column_order);
    //***tableData*































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Table_metadata/add', {































































































































































































































































































































































































































































































































      method: 'POST',































































































































































































































































































































































































































































































































      mode: 'cors',































































































































































































































































































































































































































































































































      body: formData































































































































































































































































































































































































































































































































    })































































































































































































































































































































































































































































































































      .then(response => response.json())































































































































































































































































































































































































































































































































      .then((data) => {































































































































































































































































































































































































































































































































        this.showToast(data.message, data.status);































































































































































































































































































































































































































































































































        if (data.status === "success") {































































































































































































































































































































































































































































































































          this.Table_metadatafetchHandler();































































































































































































































































































































































































































































































































          this.handleOffcanvasClose();































































































































































































































































































































































































































































































































          this.setState({ table_name: '', display_name: '', yes_no: [], has_rule_triggers: '', yes_no: [], auto_generate_rules: '', table_config: '', });































































































































































































































































































































































































































































































































        }































































































































































































































































































































































































































































































































      
        this.setState({ loading: false });})































































































































































































































































































































































































































































































































      .catch((error) => {































































































































































































































































































































































































































































































































        console.error("Submit error:", error);































































































































































































































































































































































































































































































































        this.showToast("Failed to save data", "error");































































































































































































































































































































































































































































































































      
        this.setState({ loading: false });});































































































































































































































































































































































































































































































































  }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  Table_metadataupdateHandler = (e) => {































































































































































































































































































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    // Validate all fields before submission































































































































































































































































































































































































































































































































    this.validateAllFields();































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    if (!this.isFormValid()) {































































































































































































































































































































































































































































































































      this.showToast("Please fix all errors before updating", "error");































































































































































































































































































































































































































































































































      return;































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    var formData = new FormData();































































































































































































































































































































































































































































































































    formData.append("sId", this.state.sId);































































































































































































































































































































































































































































































































    formData.append("uId", this.state.uId);































































































































































































































































































































































































































































































































    formData.append("table_metadata_Id", this.state.table_metadata_Id);































































































































































































































































































































































































































































































































    formData.append('table_name', this.state.table_name);































































































































































































































































































































































































































































































































    formData.append('display_name', this.state.display_name);































































































































































































































































































































































































































































































































    formData.append('has_rule_triggers', this.state.has_rule_triggers);































































































































































































































































































































































































































































































































    formData.append('auto_generate_rules', this.state.auto_generate_rules);































































































































































































































































































































































































































































































































    formData.append('table_config', this.state.table_config);































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    formData.append('column_name', this.state.column_name);































































































































































































































































    formData.append('data_type', this.state.data_type);































































































































    formData.append('length', this.state.length);































































    formData.append('is_nullable', this.state.is_nullable);































    formData.append('default_value', this.state.default_value);















    formData.append('is_primary_key', this.state.is_primary_key);







    formData.append('is_auto_increment', this.state.is_auto_increment);



    formData.append('column_comment', this.state.column_comment);

    formData.append('column_order', this.state.column_order);
    //***tableData1































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Table_metadata/update', {































































































































































































































































































































































































































































































































      method: 'POST',































































































































































































































































































































































































































































































































      mode: 'cors',































































































































































































































































































































































































































































































































      body: formData































































































































































































































































































































































































































































































































    })































































































































































































































































































































































































































































































































      .then(response => response.json())































































































































































































































































































































































































































































































































      .then((data) => {































































































































































































































































































































































































































































































































        this.showToast(data.message, data.status);































































































































































































































































































































































































































































































































        if (data.status === "success") {































































































































































































































































































































































































































































































































          this.Table_metadatafetchHandler();































































































































































































































































































































































































































































































































          this.handleOffcanvasClose();































































































































































































































































































































































































































































































































        }































































































































































































































































































































































































































































































































      
        this.setState({ loading: false });})































































































































































































































































































































































































































































































































      .catch((error) => {































































































































































































































































































































































































































































































































        console.error("Update error:", error);































































































































































































































































































































































































































































































































        this.showToast("Failed to update data", "error");































































































































































































































































































































































































































































































































      
        this.setState({ loading: false });});































































































































































































































































































































































































































































































































  }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  componentDidMount() {































































































































































































































































































































































































































































































































    this.Table_metadatafetchHandler();































































































































































































































































































































































































































































































































    this.yes_nofetchHandler();































































































































































































































































































































































































































































































































    this.yes_nofetchHandler();































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    this.yes_nofetchHandler();































    this.yes_nofetchHandler();







    this.yes_nofetchHandler();



    //***componentDidMount































































































































































































































































































































































































































































































































  }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  handletable_nameChange = (e) => {































































































































































































































































































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































































































































































































































































































    this.setState({ table_name: fieldValue });































































































































































































































































































































































































































































































































  }; handledisplay_nameChange = (e) => {































































































































































































































































































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































































































































































































































































































    this.setState({ display_name: fieldValue });































































































































































































































































































































































































































































































































  }; handlehas_rule_triggersChange = (e) => {































































































































































































































































































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































































































































































































































































































    this.setState({ has_rule_triggers: fieldValue });































































































































































































































































































































































































































































































































  }; yes_nofetchHandler = () => {































































































































































































































































































































































































































































































































    fetch(configData.api_url + "C_Yes_no/list", {  // Enter your IP address here































































































































































































































































































































































































































































































































      method: "POST",































































































































































































































































































































































































































































































































      mode: "cors",































































































































































































































































































































































































































































































































      body: {}// body data type must match "Content-Type" header































































































































































































































































































































































































































































































































    }).then(response => response.json())































































































































































































































































































































































































































































































































      .then((data) => {































































































































































































































































































































































































































































































































        if (data.status === "success") {































































































































































































































































































































































































































































































































          this.setState({ yes_no: data.list });































































































































































































































































































































































































































































































































        }































































































































































































































































































































































































































































































































      });































































































































































































































































































































































































































































































































  }; handleauto_generate_rulesChange = (e) => {































































































































































































































































































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































































































































































































































































































    this.setState({ auto_generate_rules: fieldValue });































































































































































































































































































































































































































































































































  }; yes_nofetchHandler = () => {































































































































































































































































































































































































































































































































    fetch(configData.api_url + "C_Yes_no/list", {  // Enter your IP address here































































































































































































































































































































































































































































































































      method: "POST",































































































































































































































































































































































































































































































































      mode: "cors",































































































































































































































































































































































































































































































































      body: {}// body data type must match "Content-Type" header































































































































































































































































































































































































































































































































    }).then(response => response.json())































































































































































































































































































































































































































































































































      .then((data) => {































































































































































































































































































































































































































































































































        if (data.status === "success") {































































































































































































































































































































































































































































































































          this.setState({ yes_no: data.list });































































































































































































































































































































































































































































































































        }































































































































































































































































































































































































































































































































      });































































































































































































































































































































































































































































































































  }; handletable_configChange = (e) => {































































































































































































































































































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































































































































































































































































































    this.setState({ table_config: fieldValue });































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































  handlecolumn_nameChange = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































    this.setState({ column_name: fieldValue });































































































































































































































































  }; handledata_typeChange = (e) => {































































































































    e.preventDefault();































































































































    const fieldValue = e.target.value;































































































































    this.setState({ data_type: fieldValue });































































































































  }; handlelengthChange = (e) => {































































    e.preventDefault();































































    const fieldValue = e.target.value;































































    this.setState({ length: fieldValue });































































  }; handleis_nullableChange = (e) => {































    e.preventDefault();































































    const fieldValue = e.target.value;































    this.setState({ is_nullable: fieldValue });































  }; yes_nofetchHandler = () => {































    fetch(configData.api_url + "C_Yes_no/list", {  // Enter your IP address here































      method: "POST",































      mode: "cors",































      body: {}// body data type must match "Content-Type" header































    }).then(response => response.json())































      .then((data) => {































        if (data.status === "success") {































          this.setState({ yes_no: data.list });































        }































      });































  }; handledefault_valueChange = (e) => {















    e.preventDefault();















    const fieldValue = e.target.value;















    this.setState({ default_value: fieldValue });















  }; handleis_primary_keyChange = (e) => {







    e.preventDefault();















    const fieldValue = e.target.value;







    this.setState({ is_primary_key: fieldValue });







  }; yes_nofetchHandler = () => {







    fetch(configData.api_url + "C_Yes_no/list", {  // Enter your IP address here







      method: "POST",







      mode: "cors",







      body: {}// body data type must match "Content-Type" header







    }).then(response => response.json())







      .then((data) => {







        if (data.status === "success") {







          this.setState({ yes_no: data.list });







        }







      });







  }; handleis_auto_incrementChange = (e) => {



    e.preventDefault();







    const fieldValue = e.target.value;



    this.setState({ is_auto_increment: fieldValue });



  }; yes_nofetchHandler = () => {



    fetch(configData.api_url + "C_Yes_no/list", {  // Enter your IP address here



      method: "POST",



      mode: "cors",



      body: {}// body data type must match "Content-Type" header



    }).then(response => response.json())



      .then((data) => {



        if (data.status === "success") {



          this.setState({ yes_no: data.list });



        }



      });



  }; handlecolumn_commentChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ column_comment: fieldValue });

  }; handlecolumn_orderChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ column_order: fieldValue });
  };//***inputFunctions































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  handleRowSelect = (row) => {































































































































































































































































































































































































































































































































    this.setState({































































































































































































































































































































































































































































































































      selectedRow: row.index,































































































































































































































































































































































































































































































































    });































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  handleRowUpdate = (newData, oldData) => {































































































































































































































































































































































































































































































































    const data = [...this.state.data];































































































































































































































































































































































































































































































































    const index = oldData.index;































































































































































































































































































































































































































































































































    data[index] = newData;































































































































































































































































































































































































































































































































    this.setState({ data });































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  handleEdit = (row) => {































































































































































































































































































































































































































































































































    console.log(`Editing row with ID ${row.id}`);































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  handleDelete = (row, index) => {































































































































































































































































































































































































































































































































    if (!window.confirm(`Are you sure you want to delete this table_metadata?`)) {































































































































































































































































































































































































































































































































      return;































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    var formData = new FormData();































































































































































































































































































































































































































































































































    formData.append('table_metadata_Id', row.table_metadata_Id);































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Table_metadata/delete', {































































































































































































































































































































































































































































































































      method: 'POST',































































































































































































































































































































































































































































































































      mode: 'cors',































































































































































































































































































































































































































































































































      body: formData































































































































































































































































































































































































































































































































    })































































































































































































































































































































































































































































































































      .then(response => response.json())































































































































































































































































































































































































































































































































      .then((data) => {































































































































































































































































































































































































































































































































        this.showToast(data.message, data.status);































































































































































































































































































































































































































































































































        if (data.status === "success") {































































































































































































































































































































































































































































































































          this.Table_metadatafetchHandler();































































































































































































































































































































































































































































































































        }































































































































































































































































































































































































































































































































      
        this.setState({ loading: false });})































































































































































































































































































































































































































































































































      .catch((error) => {































































































































































































































































































































































































































































































































        console.error("Delete error:", error);































































































































































































































































































































































































































































































































        this.showToast("Failed to delete data", "error");































































































































































































































































































































































































































































































































      
        this.setState({ loading: false });});































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  handlePageChange = (page) => {































































































































































































































































































































































































































































































































    this.setState({ currentPage: page });































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  handlePerRowsChange = (newPerPage, page) => {































































































































































































































































































































































































































































































































    this.setState({ itemsPerPage: newPerPage, currentPage: page });































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  handleFilter = (e) => {































































































































































































































































































































































































































































































































    const searchValue = e.target.value.toLowerCase();































































































































































































































































































































































































































































































































    const filteredData = this.state.data.filter((row) => {































































































































































































































































































































































































































































































































      return Object.values(row).join(" ").toLowerCase().includes(searchValue);































































































































































































































































































































































































































































































































    });































































































































































































































































































































































































































































































































    this.setState({ filteredData });































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  // Helper method to render error message































































































































































































































































































































































































































































































































  renderFieldError = (fieldName) => {































































































































































































































































































































































































































































































































    const { errors, touched } = this.state;































































































































































































































































































































































































































































































































    if (errors[fieldName] && touched[fieldName]) {































































































































































































































































































































































































































































































































      return (































































































































































































































































































































































































































































































































        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>































































































































































































































































































































































































































































































































          <i className="bi bi-exclamation-circle me-1"></i>































































































































































































































































































































































































































































































































          {errors[fieldName]}































































































































































































































































































































































































































































































































        </div>































































































































































































































































































































































































































































































































      );































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































    return null;































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  // Auto-generated form field renderer based on inputType and validation options































































































































































































































































































































































































































































































































  renderFormField = (fieldConfig) => {































































































































































































































































































































































































































































































































    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;































































































































































































































































































































































































































































































































    const value = this.state[fieldName] || "";































































































































































































































































































































































































































































































































    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    let inputElement;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    switch (inputType.toLowerCase()) {































































































































































































































































































































































































































































































































      case 'dob_child':































































































































































































































































































































































































































































































































      case 'dob_adult':































































































































































































































































































































































































































































































































      case 'date':































































































































































































































































































































































































































































































































        inputElement = (































































































































































































































































































































































































































































































































          <Form.Control































































































































































































































































































































































































































































































































            type="date"































































































































































































































































































































































































































































































































            value={value}































































































































































































































































































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            isInvalid={hasError}































































































































































































































































































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































































































































































































































































































          />































































































































































































































































































































































































































































































































        );































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'telephone':































































































































































































































































































































































































































































































































      case 'phone':































































































































































































































































































































































































































































































































        inputElement = (































































































































































































































































































































































































































































































































          <Form.Control































































































































































































































































































































































































































































































































            type="tel"































































































































































































































































































































































































































































































































            value={value}































































































































































































































































































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            isInvalid={hasError}































































































































































































































































































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































































































































































































































































































            placeholder="Enter 10-digit mobile number"































































































































































































































































































































































































































































































































          />































































































































































































































































































































































































































































































































        );































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'mail':































































































































































































































































































































































































































































































































      case 'email':































































































































































































































































































































































































































































































































        inputElement = (































































































































































































































































































































































































































































































































          <Form.Control































































































































































































































































































































































































































































































































            type="email"































































































































































































































































































































































































































































































































            value={value}































































































































































































































































































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            isInvalid={hasError}































































































































































































































































































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































































































































































































































































































            placeholder="Enter email address"































































































































































































































































































































































































































































































































          />































































































































































































































































































































































































































































































































        );































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'password':































































































































































































































































































































































































































































































































        inputElement = (































































































































































































































































































































































































































































































































          <Form.Control































































































































































































































































































































































































































































































































            type="password"































































































































































































































































































































































































































































































































            value={value}































































































































































































































































































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            isInvalid={hasError}































































































































































































































































































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































































































































































































































































































            placeholder="Enter password"































































































































































































































































































































































































































































































































          />































































































































































































































































































































































































































































































































        );































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'number':































































































































































































































































































































































































































































































































        inputElement = (































































































































































































































































































































































































































































































































          <Form.Control































































































































































































































































































































































































































































































































            type="number"































































































































































































































































































































































































































































































































            value={value}































































































































































































































































































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            isInvalid={hasError}































































































































































































































































































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































































































































































































































































































            placeholder={`Enter ${displayName.toLowerCase()}`}































































































































































































































































































































































































































































































































          />































































































































































































































































































































































































































































































































        );































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'pan':































































































































































































































































































































































































































































































































        inputElement = (































































































































































































































































































































































































































































































































          <Form.Control































































































































































































































































































































































































































































































































            type="text"































































































































































































































































































































































































































































































































            value={value}































































































































































































































































































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}































































































































































































































































































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            isInvalid={hasError}































































































































































































































































































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































































































































































































































































































            placeholder="ABCPA1234B"































































































































































































































































































































































































































































































































            maxLength="10"































































































































































































































































































































































































































































































































          />































































































































































































































































































































































































































































































































        );































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      case 'aadhaar':































































































































































































































































































































































































































































































































        inputElement = (































































































































































































































































































































































































































































































































          <Form.Control































































































































































































































































































































































































































































































































            type="text"































































































































































































































































































































































































































































































































            value={value}































































































































































































































































































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}































































































































































































































































































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            isInvalid={hasError}































































































































































































































































































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































































































































































































































































































            placeholder="123456789012"































































































































































































































































































































































































































































































































            maxLength="12"































































































































































































































































































































































































































































































































          />































































































































































































































































































































































































































































































































        );































































































































































































































































































































































































































































































































        break;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































      default: // text and other types































































































































































































































































































































































































































































































































        inputElement = (































































































































































































































































































































































































































































































































          <Form.Control































































































































































































































































































































































































































































































































            type="text"































































































































































































































































































































































































































































































































            value={value}































































































































































































































































































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































































































































































































































































































            isInvalid={hasError}































































































































































































































































































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































































































































































































































































































            placeholder={`Enter ${displayName.toLowerCase()}`}































































































































































































































































































































































































































































































































            maxLength={validationOptions?.maxLength || undefined}































































































































































































































































































































































































































































































































          />































































































































































































































































































































































































































































































































        );































































































































































































































































































































































































































































































































    }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    return (































































































































































































































































































































































































































































































































      <Row key={fieldName}>































































































































































































































































































































































































































































































































        <Col lg="4" md="4">































































































































































































































































































































































































































































































































          <Form.Label>































































































































































































































































































































































































































































































































            {displayName}































































































































































































































































































































































































































































































































            {validationOptions?.isRequired && <span className="text-danger">*</span>}































































































































































































































































































































































































































































































































          </Form.Label>































































































































































































































































































































































































































































































































        </Col>































































































































































































































































































































































































































































































































        <Col lg="8" md="8">































































































































































































































































































































































































































































































































          {inputElement}































































































































































































































































































































































































































































































































          {this.renderFieldError(fieldName)}































































































































































































































































































































































































































































































































        </Col>































































































































































































































































































































































































































































































































      </Row>































































































































































































































































































































































































































































































































    );































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  render() {































































































































































































































































































































































































































































































































    const { errors, touched } = this.state;































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    const paginatedData = this.state.filteredData































































































































































































































































































































































































































































































































      ? this.state.filteredData.slice(































































































































































































































































































































































































































































































































        (this.state.currentPage - 1) * this.state.itemsPerPage,































































































































































































































































































































































































































































































































        this.state.currentPage * this.state.itemsPerPage































































































































































































































































































































































































































































































































      )































































































































































































































































































































































































































































































































      : this.state.data.slice(































































































































































































































































































































































































































































































































        (this.state.currentPage - 1) * this.state.itemsPerPage,































































































































































































































































































































































































































































































































        this.state.currentPage * this.state.itemsPerPage































































































































































































































































































































































































































































































































      );































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    return (































































































































































































































































































































































































































































































































      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />































































































































































































































































































































































































































































































































        <div className="row">































































































































































































































































































































































































































































































































          <div className="col-md-12 col-sm-12 col-xs-12">































































































































































































































































































































































































































































































































            <div className="x_panel">































































































































































































































































































































































































































































































































              <div className="x_content">































































































































































































































































































































































































































































































































                <div































































































































































































































































































































































































































































































































                  id="datatable_wrapper"































































































































































































































































































































































































































































































































                  className="dataTables_wrapper form-inline































































































































































































































































































































































































































































































































                dt-bootstrap no-footer"































































































































































































































































































































































































































































































































                >































































































































































































































































































































































































































































































































                  <Row className="row">































































































































































































































































































































































































































































































































                    <div>































































































































































































































































































































































































































































































































                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Table Metadata</h3>































































































































































































































































































































































































































































































































                    </div>































































































































































































































































































































































































































































































































                    <Col































































































































































































































































































































































































































































































































                      className="d-flex justify-content-end"































































































































































































































































































































































































































































































































                      style={{ marginRight: "5px", marginTop: "20px" }}































































































































































































































































































































































































































































































































                    >































































































































































































































































































































































































































































































































                      <Button































































































































































































































































































































































































































































































































                        variant="primary" style={{ float: "right", marginBottom: "10px" }}































































































































































































































































































































































































































































































































                        className="bi bi-plus "































































































































































































































































































































































































































































































































                        onClick={this.handleOffcanvasShow}































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                        New































































































































































































































































































































































































































































































































                      </Button>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                      {/* Enhanced Add Offcanvas */}































































































































































































































































































































































































































































































































                      <Offcanvas































































































































































































































































































































































































































































































































                        show={this.state.show && !this.state.isEditing}































































































































































































































































































































































































































































































































                        onHide={this.handleOffcanvasClose}































































































































































































































































































































































































































































































































                        {...this.props}































































































































































































































































































































































































































































































































                        style={{ width: "500px" }}































































































































































































































































































































































































































































































































                        placement="end"































































































































































































































































































































































































































































































































                        backdrop="true"































































































































































































































































































































































































































































































































                      >































































































































































































































































































































































































































































































































                        <Offcanvas.Header closeButton>































































































































































































































































































































































































































































































































                          <Offcanvas.Title>Add Table_metadata</Offcanvas.Title>































































































































































































































































































































































































































































































































                        </Offcanvas.Header>































































































































































































































































































































































































































































































































                        <Offcanvas.Body>































































































































































































































































































































































































































































































































                          <Container style={{ "overflowY": "auto", height: "auto" }}>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                            {/* Error Summary */}































































































































































































































































































































































































































































































































                            {Object.keys(errors).length > 0 && (































































































































































































































































































































































































































































































































                              <div className="alert alert-danger mb-3">































































































































































































































































































































































































































































































































                                <strong>Please fix the following errors:</strong>































































































































































































































































































































































































































































































































                                <ul className="mb-0 mt-2">































































































































































































































































































































































































































































































































                                  {Object.entries(errors).map(([field, error]) => (































































































































































































































































































































































































































































































































                                    <li key={field}>{error}</li>































































































































































































































































































































































































































































































































                                  ))}































































































































































































































































































































































































































































































































                                </ul>































































































































































































































































































































































































































































































































                              </div>































































































































































































































































































































































































































































































































                            )}































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                            <Row className="divstyle">































































































































































































































































































































































































































































































































                              <Row>































































































































































































































































































































































































































































































































                                <Form>































































































































































































































































































































































































































































































































                                  <Row>































































































































































































































































































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>































































































































































































































































































































































































































































































































                                    </Col>































































































































































































































































































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































































































































































































































































































                                      <Form.Control type="text" onChange={this.handletable_nameChange} className="form-control" name="table_name" value={this.state.table_name} required="required" placeholder="Enter Table Name" />































































































































































































































































































































































































































































































































                                    </Col>































































































































































































































































































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_name} </div>































































































































































































































































































































































































































































































































                                  </Row><br /><Row>































































































































































































































































































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Display Name</Form.Label>































































































































































































































































































































































































































































































































                                    </Col>































































































































































































































































































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































































































































































































































































































                                      <Form.Control type="text" onChange={this.handledisplay_nameChange} className="form-control" name="display_name" value={this.state.display_name} required="required" placeholder="Enter Display Name" />































































































































































































































































































































































































































































































































                                    </Col>































































































































































































































































































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.display_name} </div>































































































































































































































































































































































































































































































































                                  </Row><br /><Row>































































































































































































































































































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Has Rule Triggers</Form.Label>































































































































































































































































































































































































































































































































                                    </Col>































































































































































































































































































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































































































































































































































































































                                      <select className="form-select" name="tableName" onChange={this.handlehas_rule_triggersChange}>































































































































































































































































































































































































































































































































                                        <option defaultValue> Select Has Rule Triggers </option>































































































































































































































































































































































































































































































































                                        {this.state.yes_no.map((api, index, idx) => (































































































































































































































































































































































































































































































































                                          <option key={index} value={api.value}> {api.value} </option>































































































































































































































































































































































































































































































































                                        ))}































































































































































































































































































































































































































































































































                                      </select>































































































































































































































































































































































































































































































































                                    </Col>































































































































































































































































































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.has_rule_triggers} </div>































































































































































































































































































































































































































































































































                                  </Row><br /><Row>































































































































































































































































































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Auto Generate Rules</Form.Label>































































































































































































































































































































































































































































































































                                    </Col>































































































































































































































































































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































































































































































































































































































                                      <select className="form-select" name="tableName" onChange={this.handleauto_generate_rulesChange}>































































































































































































































































































































































































































































































































                                        <option defaultValue> Select Auto Generate Rules </option>































































































































































































































































































































































































































































































































                                        {this.state.yes_no.map((api, index, idx) => (































































































































































































































































































































































































































































































































                                          <option key={index} value={api.value}> {api.value} </option>































































































































































































































































































































































































































































































































                                        ))}































































































































































































































































































































































































































































































































                                      </select>































































































































































































































































































































































































































































































































                                    </Col>































































































































































































































































































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.auto_generate_rules} </div>































































































































































































































































































































































































































































































































                                  </Row><br /><Row>































































































































































































































































































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Table Config</Form.Label>































































































































































































































































































































































































































































































































                                    </Col>































































































































































































































































































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































































































































































































































































































                                      <Form.Control type="text" onChange={this.handletable_configChange} className="form-control" name="table_config" value={this.state.table_config} required="required" placeholder="Enter Table Config" />































































































































































































































































































































































































































































































































                                    </Col>































































































































































































































































































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_config} </div>































































































































































































































































































































































































































































































































                                  </Row><br />































































































































































































































































































































































































































































































































                                  {/* Auto-generated form content with validation */}































































































































































































































































































































































































































































































































                                </Form>































































































































































































































































































































































































































































































































                              </Row>































































































































































































































































































































































































































































































































                            </Row>































































































































































































































































































































































































































































































































                            <Row>































































































































































































































































































































































































































































































































                              <Col































































































































































































































































































































































































































































































































                                className="d-flex justify-content-end"































































































































































































































































































































































































































































































































                                style={{ marginRight: "50px" }}































































































































































































































































































































































































































































































































                              >































































































































































































































































































































































































































































































































                                <Button































































































































































































































































































































































































































































































































                                  className="button"































































































































































































































































































































































































































































































































                                  variant="success"































































































































































































































































































































































































































































































































                                  onClick={this.Table_metadatasubmitHandler}































































































































































































































































































































































































































































































































                                  disabled={!this.isFormValid()}































































































































































































































































































































































































































































































































                                  style={{































































































































































































































































































































































































































































































































                                    marginTop: "20px",































































































































































































































































































































































































































































































































                                  }}































































































































































































































































































































































































































































































































                                >































































































































































































































































































































































































































































































































                                  Save































































































































































































































































































































































































































































































































                                </Button>































































































































































































































































































































































































































































































































                              </Col>































































































































































































































































































































































































































































































































                            </Row>































































































































































































































































































































































































































































































































                          </Container>































































































































































































































































































































































































































































































































                        </Offcanvas.Body>































































































































































































































































































































































































































































































































                      </Offcanvas>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                      {/* Enhanced Edit Offcanvas */}































































































































































































































































































































































































































































































































                      {this.state.isEditing && (































































































































































































































































































































































































































































































































                        <Offcanvas































































































































































































































































































































































































































































































































                          show={this.state.isEditing}































































































































































































































































































































































































































































































































                          onHide={this.handleOffcanvasClose}































































































































































































































































































































































































































































































































                          {...this.props}































































































































































































































































































































































































































































































































                          style={{ width: "500px" }}































































































































































































































































































































































































































































































































                          placement="end"































































































































































































































































































































































































































































































































                          backdrop="true"































































































































































































































































































































































































































































































































                        >































































































































































































































































































































































































































































































































                          <Offcanvas.Header closeButton>































































































































































































































































































































































































































































































































                            <Offcanvas.Title>Edit Table_metadata</Offcanvas.Title>































































































































































































































































































































































































































































































































                          </Offcanvas.Header>































































































































































































































































































































































































































































































































                          <Offcanvas.Body>































































































































































































































































































































































































































































































































                            <Container style={{ "overflowY": "auto", height: "auto" }}>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                              {/* Error Summary */}































































































































































































































































































































































































































































































































                              {Object.keys(errors).length > 0 && (































































































































































































































































































































































































































































































































                                <div className="alert alert-danger mb-3">































































































































































































































































































































































































































































































































                                  <strong>Please fix the following errors:</strong>































































































































































































































































































































































































































































































































                                  <ul className="mb-0 mt-2">































































































































































































































































































































































































































































































































                                    {Object.entries(errors).map(([field, error]) => (































































































































































































































































































































































































































































































































                                      <li key={field}>{error}</li>































































































































































































































































































































































































































































































































                                    ))}































































































































































































































































































































































































































































































































                                  </ul>































































































































































































































































































































































































































































































































                                </div>































































































































































































































































































































































































































































































































                              )}































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                              <Row className="divstyle">































































































































































































































































































































































































































































































































                                <Row>































































































































































































































































































































































































































































































































                                  <Form>































































































































































































































































































































































































































































































































                                    <Row>































































































































































































































































































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>































































































































































































































































































































































































































































































































                                      </Col>































































































































































































































































































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































































































































































































































































































                                        <Form.Control type="text" onChange={this.handletable_nameChange} className="form-control" name="table_name" value={this.state.table_name} required="required" placeholder="Enter Table Name" />































































































































































































































































































































































































































































































































                                      </Col>































































































































































































































































































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_name} </div>































































































































































































































































































































































































































































































































                                    </Row><br /><Row>































































































































































































































































































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Display Name</Form.Label>































































































































































































































































































































































































































































































































                                      </Col>































































































































































































































































































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































































































































































































































































































                                        <Form.Control type="text" onChange={this.handledisplay_nameChange} className="form-control" name="display_name" value={this.state.display_name} required="required" placeholder="Enter Display Name" />































































































































































































































































































































































































































































































































                                      </Col>































































































































































































































































































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.display_name} </div>































































































































































































































































































































































































































































































































                                    </Row><br /><Row>































































































































































































































































































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Has Rule Triggers</Form.Label>































































































































































































































































































































































































































































































































                                      </Col>































































































































































































































































































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































































































































































































































































































                                        <select className="form-select" name="tableName" onChange={this.handlehas_rule_triggersChange}>































































































































































































































































































































































































































































































































                                          <option defaultValue> Select Has Rule Triggers </option>































































































































































































































































































































































































































































































































                                          {this.state.yes_no.map((api, index, idx) => (































































































































































































































































































































































































































































































































                                            <option key={index} value={api.value}> {api.value} </option>































































































































































































































































































































































































































































































































                                          ))}































































































































































































































































































































































































































































































































                                        </select>































































































































































































































































































































































































































































































































                                      </Col>































































































































































































































































































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.has_rule_triggers} </div>































































































































































































































































































































































































































































































































                                    </Row><br /><Row>































































































































































































































































































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Auto Generate Rules</Form.Label>































































































































































































































































































































































































































































































































                                      </Col>































































































































































































































































































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































































































































































































































































































                                        <select className="form-select" name="tableName" onChange={this.handleauto_generate_rulesChange}>































































































































































































































































































































































































































































































































                                          <option defaultValue> Select Auto Generate Rules </option>































































































































































































































































































































































































































































































































                                          {this.state.yes_no.map((api, index, idx) => (































































































































































































































































































































































































































































































































                                            <option key={index} value={api.value}> {api.value} </option>































































































































































































































































































































































































































































































































                                          ))}































































































































































































































































































































































































































































































































                                        </select>































































































































































































































































































































































































































































































































                                      </Col>































































































































































































































































































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.auto_generate_rules} </div>































































































































































































































































































































































































































































































































                                    </Row><br /><Row>































































































































































































































































































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Table Config</Form.Label>































































































































































































































































































































































































































































































































                                      </Col>































































































































































































































































































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































































































































































































































































































                                        <Form.Control type="text" onChange={this.handletable_configChange} className="form-control" name="table_config" value={this.state.table_config} required="required" placeholder="Enter Table Config" />































































































































































































































































































































































































































































































































                                      </Col>































































































































































































































































































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_config} </div>































































































































































































































































































































































































































































































































                                    </Row><br />































































































































































































































































































































































































































































































































                                    {/* Auto-generated form content with validation */}































































































































































































































































































































































































































































































































                                  </Form>































































































































































































































































































































































































































































































































                                </Row>































































































































































































































































































































































































































































































































                              </Row>































































































































































































































































































































































































































































































































                              <Row>































































































































































































































































































































































































































































































































                                <Col































































































































































































































































































































































































































































































































                                  className="d-flex justify-content-end"































































































































































































































































































































































































































































































































                                  style={{ marginRight: "50px" }}































































































































































































































































































































































































































































































































                                >































































































































































































































































































































































































































































































































                                  <Button































































































































































































































































































































































































































































































































                                    className="button"































































































































































































































































































































































































































































































































                                    variant="success"































































































































































































































































































































































































































































































































                                    onClick={this.Table_metadataupdateHandler}































































































































































































































































































































































































































































































































                                    disabled={!this.isFormValid()}































































































































































































































































































































































































































































































































                                    style={{































































































































































































































































































































































































































































































































                                      marginTop: "20px",































































































































































































































































































































































































































































































































                                    }}































































































































































































































































































































































































































































































































                                  >































































































































































































































































































































































































































































































































                                    Update































































































































































































































































































































































































































































































































                                  </Button>































































































































































































































































































































































































































































































































                                </Col>































































































































































































































































































































































































































































































































                              </Row>































































































































































































































































































































































































































































































































                            </Container>































































































































































































































































































































































































































































































































                          </Offcanvas.Body>































































































































































































































































































































































































































































































































                        </Offcanvas>































































































































































































































































































































































































































































































































                      )}































































































































































































































































































































































































































































































































                      {/*offcanvas is over */}































































































































































































































































































































































































































































































































                    </Col>































































































































































































































































































































































































































































































































                  </Row>































































































































































































































































































































































































































































































































                  <br />































































































































































































































































































































































































































































































































                  <Row>































































































































































































































































































































































































































































































































                    <div style={{ "marginRight": "5px" }}>































































































































































































































































































































































































































































































































                      {/* searchbar,pagination,filter */}































































































































































































































































































































































































































































































































                      <input































































































































































































































































































































































































































































































































                        type="text"































































































































































































































































































































































































































































































































                        style={{ float: "left", marginBottom: "10px" }}































































































































































































































































































































































































































































































































                        onChange={this.handleFilter}































































































































































































































































































































































































































































































































                        placeholder="Search..."































































































































































































































































































































































































































































































































                      />































































































































































































































































































































































































































































































































                      <DataTable































































































































































































































































































































































































































































































































                        data={paginatedData}































































































































































































































































































































































































































































































































                        columns={this.state.tableClms}































































































































































































































































































































































































































































































































                        pagination































































































































































































































































































































































































































































































































                        paginationServer































































































































































































































































































































































































































































































































                        paginationTotalRows={































































































































































































































































































































































































































































































































                          this.state.filteredData































































































































































































































































































































































































































































































































                            ? this.state.filteredData.length































































































































































































































































































































































































































































































































                            : this.state.data.length































































































































































































































































































































































































































































































































                        }































































































































































































































































































































































































































































































































                        onChangeRowsPerPage={this.handlePerRowsChange}































































































































































































































































































































































































































































































































                        onChangePage={this.handlePageChange}































































































































































































































































































































































































































































































































                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}































































































































































































































































































































































































































































































































                        keyField="id"































































































































































































































































































































































































































































































































                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"































































































































































































































































































































































































































































































































                      />































































































































































































































































































































































































































































































































                    </div>































































































































































































































































































































































































































































































































                  </Row>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                </div>































































































































































































































































































































































































































































































































              </div>































































































































































































































































































































































































































































































































            </div>































































































































































































































































































































































































































































































































          </div>































































































































































































































































































































































































































































































































        </div>































































































































































































































































































































































































































































































































      </div>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    );































































































































































































































































































































































































































































































































  }































































































































































































































































































































































































































































































































}